import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { FcinputComponent } from '../fcinput';
import { Router } from '@angular/router';
/**
 * fc-progresscircleåå½¢è¿åº¦æ¡
 * 
 * å±ç¤ºæä½çå½åè¿åº¦ã
 * 
 * å½ä¸ä¸ªæä½ä¼ææ­å½åçé¢ï¼æèéè¦å¨åå°è¿è¡ï¼ä¸èæ¶å¯è½è¶è¿2ç§æ¶ã
 * 
 * å½éè¦æ¾ç¤ºä¸ä¸ªæä½å®æçç¾åæ¯æ¶ã
 * 
 */
@Component({
    selector: 'fc-progresscircle',
    template: `
    <nz-spin   [nzTip]="fcTip" [nzSize]="fcSize">

    </nz-spin>
    `,
    styles: [`
    
    `]
})
export class FcprogresscircleComponent extends FcinputComponent {
     /**æå­åå®¹*/
    @Input()
    fcTip: string;
    constructor(public provider: ProvidersService, private router: Router) {
        super(provider, 'fc-progresscircle');
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
    }
}
